import React from 'react';

const ArticleIntro = () => {
    return (
        <section className="w-full bg-white py-20 px-6 sm:px-12 text-center">
            {/* Listen label */}
            <p className="uppercase text-gray-500 text-sm tracking-wide mb-2">
                Listen to this episode
            </p>

            {/* Audio Player */}
            <div className="mb-10 flex justify-center">
                <audio controls className="w-full max-w-md">
                    <source src="/audio/episode1.mp3" type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            </div>

            {/* Article Text */}
            <div className="max-w-lg mx-auto text-left space-y-6 text-[17px] leading-relaxed text-gray-900">
                <p>
                    Only a generation ago, problems like this didn’t exist. But as the iPhone has now become a teenager,
                    launched 15 years ago, it not only wants the keys to the car but to drive our lives as well. And our
                    lives, for better or worse, have been changed.
                </p>
                <p>
                    Smartphones now form a physical connection with us. It quite literally is our first and last touches
                    of the day. We customize, cradle and caress our new phones in our hand, like cooing babies. We panic
                    and mourn when they are lost or damaged, or just run out of battery. How obsessed are we? Do they
                    deserve to be with us 24-7?
                </p>
                <p>
                    Phones promise us so much, but at what cost? Science is telling us one thing but society says something else.
                    <br />
                    <em>To better understand how the average person actually…</em>
                </p>
            </div>
        </section>
    );
};

export default ArticleIntro;
